import React from 'react';
import _ from 'lodash';
import { Button } from '@unite-us/app-components';
import AddProgramsSection from '../../../Browse/AddProgramsSection/AddProgramsSection';

export function renderServiceTypeSection(serviceTypeField, toggleBrowse, isFetchingNetworkGroups) {
  if (_.isEmpty(serviceTypeField.value)) return null;
  return (
    <AddProgramsSection
      toggleBrowse={toggleBrowse}
      isFetchingNetworkGroups={isFetchingNetworkGroups}
    />
  );
}

export function renderAuthRequiredMessage(feeScheduleProgramId, showOrgAddButton) {
  if (_.isNull(feeScheduleProgramId) || !showOrgAddButton) return null;
  return (
    <div data-testid="auth-required-message">
      <p className="my-2 italic">
        This program requires authorization. To send this referral to a provider that shares this program, click
        <strong> Add Another Recipient</strong>.
      </p>
      <p className="my-2 italic">
        To send a referral to a different program, click
        <strong> Add Another Referral</strong> at the bottom of this page.
      </p>
    </div>
  );
}

export function renderAddButton({
  showOrgAddButton, hide, disableOrgAddButton, addGroupField,
}) {
  if (!showOrgAddButton || hide) return null;
  return (
    <div className="row">
      <div className="col-xs-12">
        <Button
          className={'mb-one mt-one mb-20 -mt-2'}
          disabled={disableOrgAddButton}
          label={'+ ADD ANOTHER PROGRAM BY QUICK ADD'}
          onClick={addGroupField}
        />
      </div>
    </div>
  );
}
